export default __webpack_public_path__ + "static/media/stay.f97a32b1.mp4";